import * as angular from "angular";
import {IController} from "angular";
import {AnalyticsService} from "../../modules/commons/services/analytics-service.service";

export class OrganizationMainViewComponent implements IController {

  organization: any;

  public isLoaded: boolean = false;
  public selectedSkin: any;

  constructor(private IAMPermissions,private UserService, private intercom, private analyticsService: AnalyticsService, private triSkins) {
  }

  $onInit() {
    this.selectedSkin = this.triSkins.getCurrent();

    this.IAMPermissions.setOrganizationPermissions(this.organization.id).then((permissions) => {
      const user = this.UserService.getCurrentUser();
      const organizationName = 'Organization - ' + this.organization.name;
      this.intercom.update(user, organizationName, permissions,
        this.organization);
      this.analyticsService.initOrganization(user, this.organization,
        permissions);
    })
      .finally(() => {
        this.isLoaded = true;
      })
  }


}

angular
  .module('bringoz.admin.commons')
  .component('organizationMainView', {
    bindings: {
      organization: '<'
    },
    template: require('./organization-main-view.html').default,
    controller: OrganizationMainViewComponent
  });
